import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@shared/services/auth.service';
import {inject} from '@angular/core';
import {EQueryParam} from '@shared/enums/query-param';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';

export const canAuthGuard: CanActivateFn = (_route, state) => {
  return inject(AuthService).user()
    ? true
    : inject(Router).createUrlTree([`/${EEndpointApp.Auth}/${EEndpointApp.SignIn}`], {
        queryParams: {
          [EQueryParam.RETURN_URL]: state.url,
        },
      });
};
